import { useContext } from "react";
import { Switch, Route } from "react-router-dom";

/// Css
import "../assets/css/index.css";
import "../assets/css/chart.css";
import "../assets/css/step.css";

import Nav from "../components/layouts/nav";
import { ROUTE } from "../constants/app_routes";
import ScrollToTop from "../components/layouts/ScrollToTop";
import Dashboard from "../pages/dashboard";
import { ThemeContext } from "../context/ThemeContext";
import BetOption from "../pages/betOption";
import Staff from "../pages/staff";
import Member from "../pages/member";
import Topup from "../pages/topup";
import Withdraw from "../pages/withdraw";
import Transaction from "../pages/transaction";
import Settings from "../pages/settings";
import Chat from "../pages/chat";
import Bet from "../pages/bet";
import Country from "../pages/country";
import Room from "../pages/room";
import Bot from "../pages/bot";
import AdminPage from "../pages/admin";
import BranchPage from "../pages/branch";
import DigitalWalletPage from "../pages/digitalWallet";
import DepositPage from "../pages/deposit";

const AppRoutes = () => {
  const { menuToggle } = useContext(ThemeContext);
  const routes = [
    { url: "", component: Dashboard },
    { url: ROUTE.dashboard, component: Dashboard },
    { url: ROUTE.member, component: Member },
    { url: ROUTE.bet, component: Bet },
    { url: ROUTE.bet_option, component: BetOption },
    { url: ROUTE.staff, component: Staff },
    { url: ROUTE.topup, component: Topup },
    { url: ROUTE.withdraw, component: Withdraw },
    { url: ROUTE.transaction, component: Transaction },
    { url: ROUTE.setting, component: Settings },
    { url: ROUTE.chat, component: Chat },
    { url: ROUTE.country, component: Country },
    { url: ROUTE.room, component: Room },
    { url: ROUTE.bot, component: Bot },
    { url: ROUTE.admin, component: AdminPage },
    { url: ROUTE.branch, component: BranchPage },
    { url: ROUTE.digitalWallet, component: DigitalWalletPage },
    { url: ROUTE.deposit, component: DepositPage },
  ];
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const pagePath = path.split("-").includes("page");
  const isMainPage = !pagePath;
  return (
    <>
      <div
        id={`${isMainPage ? "main-wrapper" : ""}`}
        className={`${isMainPage ? "show" : "mh100vh"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {isMainPage && <Nav />}
        <div className={`${isMainPage ? "content-body" : ""}`}>
          <div
            className={`${isMainPage ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60 }}
          >
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
        </div>
      </div>
      <ScrollToTop />
    </>
  );
};

export default AppRoutes;
